import axios, { AxiosResponse } from 'axios';

import { IApiModifyResponse, IToolUserSettings } from '@/types';

export const changePassword = (params: Record<string, string>): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.get('/api/toolUser/changePassword', { params });
};

export const changeTimeZone = (timeZoneCode: string): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.get('/api/toolUser/changeTimeZone', { params: { timezone: timeZoneCode } });
};

export const changeSettings = (settings: IToolUserSettings): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.post('/api/toolUser/changeSettings', { toolUserSettings: settings });
};

export const checkDocuments = (): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.get('/api/toolUser/checkDocuments');
};

export const uploadDocuments = (params: FormData): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.post('/api/toolUser/uploadDocuments', params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
